( function ( _s ) {
	_s.fn.splideInit = function () {
		return this.each( el => {
			const _self = _s( el );
			const config = JSON.parse( _self.attr( 'data-splide' ) || '{}' );
			const splideInstance = new Splide( el, config );

			splideInstance.on( 'mounted', () => {
				_self.addClass( 'is-initialized' );
			} );

			splideInstance.mount();


			if ( config.refresh_on_resize ) {
				_s( window ).on(
					'resize',
					window.debounce( () => {
						splideInstance.refresh();
					}, 100 )
				);
			}

            if ( config.emit_events ) {
                config.emit_events.forEach( evName => {
                    splideInstance.on( evName, ( a, b, c ) => {
                        _self.trigger( `sp-splide-${ evName }`, {
                            newIndex: a,
                            prevIndex: b,
                            destIndex: c,
                        } );
                    } );
                } );
            }
        } );
    };

    _s( document ).ready( () => {
        const _elements = _s( '[splide-init]' );
        if ( !_elements.el.length ) return;
        if ( typeof window.splideWhenReady === 'function' ) {
            window.splideWhenReady( () => _elements.splideInit() );
        } else if ( typeof window.Splide !== 'undefined' ) {
            _elements.splideInit();
        }
    } );
} )( window._s );
